export default __webpack_public_path__ + "static/media/warning--ferry--g1.0879199d.png";